<template>
  <div>
    <h1>Thank You! Your response has been recorded!</h1>
    <router-link to="/">
      <button>Back to form</button>
    </router-link>
  </div>
</template>

<script>
  export default {
    name: "SubmissionSuccess"
  }
</script>

<style scoped>
h1{
  padding-left: 35vw;
  
}
</style>